export const ACTIONS = {
    SET_ORIGIN_ADDRESS: 'SET_ORIGIN_ADDRESS',
    SET_ORIGIN_GEOCODE: 'SET_ORIGIN_GEOCODE',
    SET_FREE_KEYWORD: 'SET_FREE_KEYWORD',
    SET_FREE_KEYWORDS: 'SET_FREE_KEYWORDS',
    SET_TARGET_KEYWORDS: 'SET_TARGET_KEYWORDS',
    SET_RADIUS: 'SET_RADIUS',
    SET_RECOMMEND_CHECKS: 'SET_RECOMMEND_CHECKS',
    SET_ERROR_MESSAGES: 'SET_ERROR_MESSAGES',
    SET_RESULTS: 'SET_RESULTS',
    CLEAR_RESULTS: 'CLEAR_RESULTS',
    SET_LOADING: 'SET_LOADING',
}